export default __webpack_public_path__ + "9d4fdc409a91f0dc946ef1c427ce4615.jpg";